import { render } from "./stackContainer.vue?vue&type=template&id=54ed0c3c&ts=true"
import script from "./stackContainer.vue?vue&type=script&lang=ts"
export * from "./stackContainer.vue?vue&type=script&lang=ts"

import "./stackContainer.vue?vue&type=style&index=0&id=54ed0c3c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__